export default __webpack_public_path__ + "static/media/img8.6e1ef160.PNG";